import { Component } from '@theme/component';
import { ThemeEvents, ZoomMediaSelectedEvent } from '@theme/events';
import { StandardEvents, ProductSelectEvent } from '@shopify/events';
import { morph, MORPH_OPTIONS } from '@theme/morph';

export class MediaGallery extends Component {
  connectedCallback() {
    super.connectedCallback();

    if (this.#controller.signal.aborted) this.#controller = new AbortController();
    const { signal } = this.#controller;
    const target = this.closest('.shopify-section, dialog');

    target?.addEventListener(StandardEvents.productSelect, this.#handleProductSelect, { signal });
    this.refs.zoomDialogComponent?.addEventListener(ThemeEvents.zoomMediaSelected, this.#handleZoomMediaSelected, {
      signal,
    });
  }

  #controller = new AbortController();

  disconnectedCallback() {
    super.disconnectedCallback();

    this.#controller.abort();
  }

  #handleProductSelect = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;

    event.promise
      .then(({ detail }) => {
        if (!detail?.html) return;

        const { html } = detail;
        const newMediaGallery = html.querySelector('media-gallery');
        if (!newMediaGallery) return;

        if (!this.isConnected) return;

        const countSlides = (root) =>
          [...root.querySelectorAll('slideshow-slide')].filter(
            (s) => !s.hasAttribute('hidden') || s.hasAttribute('reveal')
          ).length;

        const oldSlideCount = countSlides(this);
        const newSlideCount = countSlides(newMediaGallery);

        if (oldSlideCount > 1 !== newSlideCount > 1) {
          this.replaceWith(newMediaGallery);
          return;
        }

        morph(this, newMediaGallery, {
          ...MORPH_OPTIONS,

          childrenOnly: false,

          getNodeKey: (node) => (node instanceof HTMLElement ? node.dataset.mediaId : undefined),
        });

        queueMicrotask(() => {
          if (!this.isConnected) return;
          const slideshow = this.slideshow;
          if (slideshow && typeof slideshow.select === 'function') {

            slideshow.select(slideshow.initialSlideIndex, undefined, { animate: false });
          }
        });
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[media-gallery] Event promise rejected:', error);
      });
  };

  #handleZoomMediaSelected = async (event) => {
    this.slideshow?.select(event.detail.index, undefined, { animate: false });
  };

  zoom(index, event) {
    this.refs.zoomDialogComponent?.open(index, event);
  }

  preloadImage(index) {
    const zoomDialogMedia = this.refs.zoomDialogComponent?.refs.media[index];
    if (!zoomDialogMedia) return;

    this.refs.zoomDialogComponent?.loadHighResolutionImage(zoomDialogMedia);
  }

  get slideshow() {
    return this.refs.slideshow;
  }

  get media() {
    return this.refs.media;
  }

  get presentation() {
    return this.dataset.presentation;
  }
}

if (!customElements.get('media-gallery')) {
  customElements.define('media-gallery', MediaGallery);
}
